import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { style: {"width":"100%","height":"100%","min-width":"1300px","padding":"0"} }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, {
        ref: "head",
        class: "header1",
        height: "60px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Header)
        ]),
        _: 1
      }, 512),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, {
            class: "aside2",
            width: "200px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Menu)
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, {
            class: "aside2 router",
            style: _normalizeStyle({height:_ctx.height+'px'})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, {
                justify: "center",
                type: "flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view, { style: {"width":"95%","min-width":"1000px"} }, {
                    default: _withCtx(({ Component }) => [
                      _createVNode(_Transition, null, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}